<!--<template>-->
<!--  <div class="about">-->
<!--    <h1>This is an about page</h1>-->
<!--    -->
<!--  </div>-->
<!--</template>-->

<template>
  <div class="main">
    <!--  <div style="width: 100%;height: 600px;background-color: red;"></div>-->
    <div class="top">
      <img
        src="https://cos.midongtech.xyz/api-web/static/h5/md_web_logo.png"
        alt=""
        :class="ISphone ? logoImgPhone : logoImg"
      />
      <img
        src="https://cos.midongtech.xyz/api-web/static/h5/md_web_wjxh.png"
        alt=""
        :class="ISphone ? wjxhImgPhone : wjxhImg"
      />
    </div>

    <div :class="ISphone ? textDescPhone : textDesc">功能正在开发中，敬请期待</div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "",
  data() {
    return {
      ISphone: false,
      logoImg: "logoImg",
      wjxhImg: "wjxhImg",
      textDesc: "textDesc",
      logoImgPhone: "logoImgPhone",
      wjxhImgPhone: "wjxhImgPhone",
      textDescPhone: "textDescPhone",
    };
  },
  mounted() {
    this.ISphone = this.$appdata.ISphone;
    console.log("this.ISphone:", this.ISphone);
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.main {
  height: 80vh;
  display: flex;
  flex-direction: column;
}
.top {
  display: flex;
  margin: 10px;
  align-items: center;
  flex-direction: row;
}

.logoImg {
  height: 50px;
}

.wjxhImg {
  height: 70px;
  margin-left: 10px;
}

.textDesc {
  font-size: 32px;
  color: #222222;
  font-weight: bold;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
}

.logoImgPhone {
  height: 8vw;
}

.wjxhImgPhone {
  height: 12vw;
  margin-left: 10px;
}

.textDescPhone {
  font-size: 6vw;
  color: #222222;
  font-weight: bold;
  position: absolute;
  width: 100%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
}
</style>
